import React, { useState, useEffect } from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { useStyle } from './PrequalStyle.js';
import { useWindowDimension } from './windowDimensions.js';

export default function EirPrequalUnderMaintenanceForm(props) {
    const classes = useStyle();
    const [width ,height]=useWindowDimension();
    return (
        <Grid container spacing={0} className={classes.UnderMaintenanceContainer}>
            <Grid item xs={width >= 1020 ? 8 : 12}>
                <Typography className={classes.UnderMaintenanceText}>
                    {props.underMaintenanceText}
                </Typography>
            </Grid>
            <Grid item xs={width >= 1020 ? 4 : 12} className={classes.UnderMaintenanceCTA}>
                <Button
                    id='check_via_eircode'
                    disableRipple={true}
                    className={classes.UnderMaintenanceCTAButton}
                    onClick={()=>{window.location.href = props.underMaintenanceRedirectURL;}}
                >
                    {props.underMaintenanceCTAText}
                </Button>
            </Grid>
        </Grid>
    );
}
